<template>
  <div>
    <div class="text-xl font-bold text-text leading-tight mb-8">{{ $t('listTitle') }}</div>
    <template v-if="list.length > 0">
      <div v-for="(item,i) in list" :key="i"
           class="flex items-center rounded pl-6 lg:pl-8 pr-4 py-4
                bg-block hover:bg-bg group even:bg-bg
                transition duration-200 -mx-2 lg:-mx-6">
        <div class="text-icon mr-6 w-5">
          <font-awesome-icon icon="landmark"/>
        </div>
        <div class="text-text-secondary text-sm w-50 mr-auto -ml-0-5">{{ item.name }}</div>
        <div class="text-text-secondary text-sm w-50 mr-auto -ml-0-5">{{ !!item.commission ? item.commission : '0.00' }}
          %
        </div>
        <div class="text-text-secondary text-sm w-50 mr-auto -ml-0-5">{{ item.currency }}</div>
        <div v-if="!currentUserIsWatcher"
             class="mr-4"
             @click="$emit('edit',item)">
          <IconEdit class="opacity-0 group-hover:opacity-100
                         transition duration-200 cursor-pointer
                         text-icon hover:text-icon-hover"/>
        </div>
      </div>
    </template>
    <div v-else class="text-md pl-2 text-text">
      {{ $t('noInvestPortfolios') }}
    </div>
  </div>
</template>

<script>
import IconEdit from "@/components/icons/IconEdit";
import {mapGetters} from "vuex";

export default {
  name: "InvestmentsSettingsPortfolioList",
  components: {
    IconEdit,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    }
  },
  computed: {
    ...mapGetters('space', ['currentUserIsWatcher'])
  },
  i18n: {
    messages: {
      en: {
        listTitle: 'Portfolios list',
        noInvestPortfolios: 'You haven\'t created any portfolios'
      },
      ru: {
        listTitle: 'Список ваших портфелей',
        noInvestPortfolios: 'У вас еще нет созданных портфелей'
      }
    }
  }
}
</script>
